<script setup>
import { ref, watch } from 'vue';
import ModalTable from '@/components/utils/ModalTable.vue';
import { MODAL_GENERIC_DICTIONARY_TABLE } from '@/data/constants/modalConstants.js';

const props = defineProps({
  title: { type: String, default: '' },
  titleCssClass: { type: String, default: '' },
  modelValue: { type: String, default: null },
  placeholder: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  url: { type: String, default: null },
  columns: { type: Array, default: null },
  displayField: { type: String, default: 'name' },
  modalTitle: { type: String, default: 'Wybierz:' }
});

const emit = defineEmits(['update:modelValue']);

const internalValue = ref(props.modelValue);
const modalTable = ref(null);

watch(
  () => props.modelValue,
  (newVal) => {
    internalValue.value = newVal;
  }
);

function onManualInput() {
  emit('update:modelValue', internalValue.value);
}

function onClear() {
  internalValue.value = null;
  emit('update:modelValue', null);
}

function onPickButtonClicked() {
  modalTable.value.showModal(MODAL_GENERIC_DICTIONARY_TABLE, {
    title: props.modalTitle,
    additionalProps: {
      url: props.url,
      columns: props.columns
    }
  });
}

function onModalCompleted(item) {
  internalValue.value = item?.[props.displayField] ?? null;
  emit('update:modelValue', internalValue.value);
  modalTable.value.hide();
}

function onModalRejected() {
  modalTable.value.hide();
  internalValue.value = null;
  emit('update:modelValue', null);
}
</script>

<template>
  <div class="form-group">
    <label :class="titleCssClass">{{ props.title }}</label>
    <div class="input-group row-container">
      <input
        type="text"
        class="form-control"
        :placeholder="props.placeholder"
        :disabled="props.disabled"
        v-model="internalValue"
        @input="onManualInput"
      />

      <button
        v-if="internalValue"
        type="button"
        class="btn btn-white btn-sm"
        style="width: 35px"
        title="Wyczyść"
        @click="onClear"
      >
        x
      </button>

      <button
        v-if="props.url"
        type="button"
        class="btn btn-info btn-sm"
        style="width: 35px"
        title="Wybierz z listy"
        @click="onPickButtonClicked"
      >
        <i class="fa fa-list-ul"></i>
      </button>
    </div>
  </div>

  <ModalTable
    v-if="props.url"
    ref="modalTable"
    :showCloseButton="true"
    overrideCloseButtonText="Zamknij"
    @onModalCompleted="onModalCompleted"
    @onModalRejected="onModalRejected"
  />
</template>

<style scoped>
.row-container {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: 5px;
}
</style>
